import { render, staticRenderFns } from "./SubmitReturnOrder.vue?vue&type=template&id=2cc070df&scoped=true"
import script from "./SubmitReturnOrder.vue?vue&type=script&lang=ts"
export * from "./SubmitReturnOrder.vue?vue&type=script&lang=ts"
import style0 from "./SubmitReturnOrder.vue?vue&type=style&index=0&id=2cc070df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc070df",
  null
  
)

export default component.exports